module.exports = ".app-soft-form {\n\tmargin: 50px;\n}\n\n.dx-field-label {\n\twidth: 38%;\n}"